import { API_TOKEN } from '@/environment'
import { getAccessToken } from '@/service/activeSession'

const authHeaders = async () => {
  return {
    'Api-Token': API_TOKEN,
    Authorization: `Bearer ${await getAccessToken()}`,
  }
}
const UNSPLASH_URL = 'https://unsplash.attensi.com'
export interface Result {
  id: string
  width: number
  height: number
  alt_description: string
  urls: {
    raw: string
    full: string
    regular: string
    small: string
    thumb: string
    small_s3: string
  }
  user: {
    name: string
    links: {
      html: string
    }
  }
}

export const getUnsplashPhotos = async (
  query: string,
  page: number = 1,
  per_page: number = 15
): Promise<Result[]> => {
  const response = await fetch(
    `${UNSPLASH_URL}/search/photos?query=${query}&page=${page}&per_page=${per_page}`,
    { headers: await authHeaders() }
  )
  const json = await response.json()
  return json.results
}

export const triggerUnsplashImageDownload = async (id: string) => {
  const response = await fetch(`${UNSPLASH_URL}/photos/${id}/download`, {
    headers: await authHeaders(),
  })
  const json = await response.json()
  return json
}
